/* tslint:disable */
/* eslint-disable */
/**
 * Entities API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'address_1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'address_2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface DatasetJobGenericError
 */
export interface DatasetJobGenericError {
    /**
     * 
     * @type {string}
     * @memberof DatasetJobGenericError
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface EntitiesValue
 */
export interface EntitiesValue {
}
/**
 * 
 * @export
 * @interface EntityCaseSummary
 */
export interface EntityCaseSummary {
    /**
     * 
     * @type {Set<string>}
     * @memberof EntityCaseSummary
     */
    'assignees'?: Set<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EntityCaseSummary
     */
    'status'?: EntityCaseSummaryStatusEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityCaseSummaryStatusEnum {
    REVIEW_REQUIRED = 'review_required',
    NO_PENDING_REVIEW = 'no_pending_review'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum EntityLoadMode {
    SHALLOW = 'shallow',
    ENRICHED = 'enriched'
}


/**
 * 
 * @export
 * @interface EntityMap
 */
export interface EntityMap {
    /**
     * 
     * @type {{ [key: string]: EntityResource; }}
     * @memberof EntityMap
     */
    'entities': { [key: string]: EntityResource; };
}
/**
 * 
 * @export
 * @interface EntityResource
 */
export interface EntityResource {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof EntityResource
     */
    '_id': string;
    /**
     * 
     * @type {number}
     * @memberof EntityResource
     */
    '_etag': number;
    /**
     * 
     * @type {string}
     * @memberof EntityResource
     */
    '_schema': string;
}
/**
 * 
 * @export
 * @interface EntityResourcePage
 */
export interface EntityResourcePage {
    /**
     * 
     * @type {Array<EntityResource>}
     * @memberof EntityResourcePage
     */
    'entities': Array<EntityResource>;
    /**
     * 
     * @type {{ [key: string]: EntityCaseSummary; }}
     * @memberof EntityResourcePage
     */
    'cases'?: { [key: string]: EntityCaseSummary; } | null;
    /**
     * 
     * @type {string}
     * @memberof EntityResourcePage
     */
    'next_page_token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityResourcePage
     */
    'previous_page_token'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityResourcePageRelatedV2
 */
export interface EntityResourcePageRelatedV2 {
    /**
     * 
     * @type {Array<EntityResource>}
     * @memberof EntityResourcePageRelatedV2
     */
    'entities': Array<EntityResource>;
    /**
     * 
     * @type {string}
     * @memberof EntityResourcePageRelatedV2
     */
    'next_cursor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityResourcePageRelatedV2
     */
    'previous_cursor'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityResourcePageV2
 */
export interface EntityResourcePageV2 {
    /**
     * 
     * @type {Array<EntityWithReviewStatus>}
     * @memberof EntityResourcePageV2
     */
    'entities': Array<EntityWithReviewStatus>;
    /**
     * 
     * @type {string}
     * @memberof EntityResourcePageV2
     */
    'next_cursor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityResourcePageV2
     */
    'previous_cursor'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityUploadDatasetJob
 */
export interface EntityUploadDatasetJob {
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof EntityUploadDatasetJob
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'status': EntityUploadDatasetJobStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof EntityUploadDatasetJob
     */
    'error'?: DatasetJobGenericError | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntityUploadDatasetJob
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJob
     */
    'type': EntityUploadDatasetJobTypeEnum;
    /**
     * 
     * @type {EntityUploadDatasetJobRequest}
     * @memberof EntityUploadDatasetJob
     */
    'request': EntityUploadDatasetJobRequest;
    /**
     * 
     * @type {EntityUploadDatasetJobResponse}
     * @memberof EntityUploadDatasetJob
     */
    'response'?: EntityUploadDatasetJobResponse | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}
/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobTypeEnum {
    ENTITY_UPLOAD = 'entity_upload'
}

/**
 * 
 * @export
 * @interface EntityUploadDatasetJobRequest
 */
export interface EntityUploadDatasetJobRequest {
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobRequest
     */
    'environment': EntityUploadDatasetJobRequestEnvironmentEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobRequest
     */
    'entity_schema': EntityUploadDatasetJobRequestEntitySchemaEnum;
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobRequest
     */
    'entity_id': string;
}

/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobRequestEnvironmentEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
    * @export
    * @enum {string}
    */
export enum EntityUploadDatasetJobRequestEntitySchemaEnum {
    ENTITY = 'Entity'
}

/**
 * 
 * @export
 * @interface EntityUploadDatasetJobRequestBody
 */
export interface EntityUploadDatasetJobRequestBody {
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobRequestBody
     */
    'file_name': string;
}
/**
 * 
 * @export
 * @interface EntityUploadDatasetJobResponse
 */
export interface EntityUploadDatasetJobResponse {
    /**
     * 
     * @type {string}
     * @memberof EntityUploadDatasetJobResponse
     */
    's3_presigned_url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EntityUploadDatasetJobResponse
     */
    's3_presigned_fields': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface EntityWithReviewStatus
 */
export interface EntityWithReviewStatus {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof EntityWithReviewStatus
     */
    '_id': string;
    /**
     * 
     * @type {number}
     * @memberof EntityWithReviewStatus
     */
    '_etag': number;
    /**
     * 
     * @type {string}
     * @memberof EntityWithReviewStatus
     */
    '_schema': string;
    /**
     * 
     * @type {EntityCaseSummary}
     * @memberof EntityWithReviewStatus
     */
    'entity_case_summary': EntityCaseSummary;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Batch-load multiple entities of the same type. Optionally enrich the results.
 * @export
 * @interface LoadEntitiesRequest
 */
export interface LoadEntitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof LoadEntitiesRequest
     */
    'env': LoadEntitiesRequestEnvEnum;
    /**
     * 
     * @type {string}
     * @memberof LoadEntitiesRequest
     */
    'entity_schema': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoadEntitiesRequest
     */
    'entity_ids': Array<string>;
    /**
     * 
     * @type {EntityLoadMode}
     * @memberof LoadEntitiesRequest
     */
    'load_mode'?: EntityLoadMode;
}

/**
    * @export
    * @enum {string}
    */
export enum LoadEntitiesRequestEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}

/**
 * 
 * @export
 * @interface LoadEntitiesResponse
 */
export interface LoadEntitiesResponse {
    /**
     * 
     * @type {string}
     * @memberof LoadEntitiesResponse
     */
    'env': LoadEntitiesResponseEnvEnum;
    /**
     * 
     * @type {string}
     * @memberof LoadEntitiesResponse
     */
    'entity_schema': string;
    /**
     * 
     * @type {{ [key: string]: EntitiesValue; }}
     * @memberof LoadEntitiesResponse
     */
    'entities': { [key: string]: EntitiesValue; };
    /**
     * 
     * @type {EntityLoadMode}
     * @memberof LoadEntitiesResponse
     */
    'load_mode': EntityLoadMode;
}

/**
    * @export
    * @enum {string}
    */
export enum LoadEntitiesResponseEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}

/**
 * 
 * @export
 * @interface RelatedEntity
 */
export interface RelatedEntity {
    /**
     * 
     * @type {Relation}
     * @memberof RelatedEntity
     */
    'property': Relation;
    /**
     * 
     * @type {EntityResource}
     * @memberof RelatedEntity
     */
    'entity': EntityResource;
}
/**
 * 
 * @export
 * @interface RelatedListPage
 */
export interface RelatedListPage {
    /**
     * 
     * @type {Array<RelatedEntity>}
     * @memberof RelatedListPage
     */
    'relations': Array<RelatedEntity>;
    /**
     * 
     * @type {string}
     * @memberof RelatedListPage
     */
    'next_page_token'?: string | null;
}
/**
 * 
 * @export
 * @interface Relation
 */
export interface Relation {
    /**
     * 
     * @type {string}
     * @memberof Relation
     */
    'env': string;
    /**
     * 
     * @type {string}
     * @memberof Relation
     */
    'entity_schema': string;
    /**
     * 
     * @type {string}
     * @memberof Relation
     */
    'entity_id': string;
    /**
     * 
     * @type {string}
     * @memberof Relation
     */
    'property': string;
    /**
     * 
     * @type {number}
     * @memberof Relation
     */
    'index'?: number | null;
}
/**
 * 
 * @export
 * @interface ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
 */
export interface ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet {
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    'address_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    'address_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    'region'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    'zipcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {DeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteEnvEnum} env 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete: async (schema: string, entityId: string, env: DeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteEnvEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete', 'entityId', entityId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete', 'env', env)
            const localVarPath = `/entities/api/v1/entity/{env}/{schema}/{entity_id}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Enriched Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetEnvEnum} env 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet: async (schema: string, entityId: string, env: GetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetEnvEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet', 'entityId', entityId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet', 'env', env)
            const localVarPath = `/entities/api/v1/entities/{env}/{schema}/{entity_id}/related`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Enriched Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetEnvEnum} [env] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet: async (schema: string, entityId: string, env?: GetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetEnvEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet', 'entityId', entityId)
            const localVarPath = `/entities/api/v1/entities/{schema}/{entity_id}/related`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetEnvEnum} env 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet: async (schema: string, entityId: string, env: GetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetEnvEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet', 'entityId', entityId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet', 'env', env)
            const localVarPath = `/entities/api/v1/entity/{env}/{schema}/{entity_id}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetEnvEnum} [env] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet: async (schema: string, entityId: string, env?: GetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetEnvEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet', 'entityId', entityId)
            const localVarPath = `/entities/api/v1/entity/{schema}/{entity_id}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{env}/{schema}/{entity_id}/related_entities
         * @summary Get related entities (DEPRECATED)
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetEnvEnum} env 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet: async (schema: string, entityId: string, env: GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetEnvEnum, limit?: number, pageToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet', 'entityId', entityId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet', 'env', env)
            const localVarPath = `/entities/api/v1/entities/{env}/{schema}/{entity_id}/related_entities`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{schema}/{entity_id}/related_entities
         * @summary Get related entities (DEPRECATED)
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetEnvEnum} [env] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet: async (schema: string, entityId: string, env?: GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetEnvEnum, limit?: number, pageToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet', 'entityId', entityId)
            const localVarPath = `/entities/api/v1/entities/{schema}/{entity_id}/related_entities`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get related entities for a specific entity based on a relationship.  Two scenarios: 1. Outbound: entity_schema == from_schema - Get entities referenced by this entity 2. Inbound: entity_schema == target_schema - Get entities that reference this entity
         * @summary Get Related Entities V2
         * @param {string} entitySchema 
         * @param {string} entityId 
         * @param {string} fromSchema 
         * @param {string} propertyName 
         * @param {string} targetSchema 
         * @param {number} [pageLimit] 
         * @param {GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetEnvEnum} [env] 
         * @param {string | null} [pageCursor] 
         * @param {GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetPageDirectionEnum} [pageDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet: async (entitySchema: string, entityId: string, fromSchema: string, propertyName: string, targetSchema: string, pageLimit?: number, env?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetEnvEnum, pageCursor?: string | null, pageDirection?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetPageDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entitySchema' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet', 'entitySchema', entitySchema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet', 'entityId', entityId)
            // verify required parameter 'fromSchema' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet', 'fromSchema', fromSchema)
            // verify required parameter 'propertyName' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet', 'propertyName', propertyName)
            // verify required parameter 'targetSchema' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet', 'targetSchema', targetSchema)
            const localVarPath = `/entities/api/v2/entities/{entity_schema}/{entity_id}/related`
                .replace(`{${"entity_schema"}}`, encodeURIComponent(String(entitySchema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (fromSchema !== undefined) {
                localVarQueryParameter['from_schema'] = fromSchema;
            }

            if (propertyName !== undefined) {
                localVarQueryParameter['property_name'] = propertyName;
            }

            if (targetSchema !== undefined) {
                localVarQueryParameter['target_schema'] = targetSchema;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page[limit]'] = pageLimit;
            }

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page[cursor]'] = pageCursor;
            }

            if (pageDirection !== undefined) {
                localVarQueryParameter['page[direction]'] = pageDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get related entities for a specific entity based on a relationship.  Two scenarios: 1. Outbound: entity_schema == from_schema - Get entities referenced by this entity 2. Inbound: entity_schema == target_schema - Get entities that reference this entity
         * @summary Get Related Entities V2
         * @param {string} entitySchema 
         * @param {string} entityId 
         * @param {GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetEnvEnum} env 
         * @param {string} fromSchema 
         * @param {string} propertyName 
         * @param {string} targetSchema 
         * @param {number} [pageLimit] 
         * @param {string | null} [pageCursor] 
         * @param {GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetPageDirectionEnum} [pageDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet: async (entitySchema: string, entityId: string, env: GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetEnvEnum, fromSchema: string, propertyName: string, targetSchema: string, pageLimit?: number, pageCursor?: string | null, pageDirection?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetPageDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entitySchema' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet', 'entitySchema', entitySchema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet', 'entityId', entityId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet', 'env', env)
            // verify required parameter 'fromSchema' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet', 'fromSchema', fromSchema)
            // verify required parameter 'propertyName' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet', 'propertyName', propertyName)
            // verify required parameter 'targetSchema' is not null or undefined
            assertParamExists('getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet', 'targetSchema', targetSchema)
            const localVarPath = `/entities/api/v2/entities/{env}/{entity_schema}/{entity_id}/related`
                .replace(`{${"entity_schema"}}`, encodeURIComponent(String(entitySchema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (fromSchema !== undefined) {
                localVarQueryParameter['from_schema'] = fromSchema;
            }

            if (propertyName !== undefined) {
                localVarQueryParameter['property_name'] = propertyName;
            }

            if (targetSchema !== undefined) {
                localVarQueryParameter['target_schema'] = targetSchema;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page[limit]'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page[cursor]'] = pageCursor;
            }

            if (pageDirection !== undefined) {
                localVarQueryParameter['page[direction]'] = pageDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Schema Json Schema
         * @param {GetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetSchemaEnum} schema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet: async (schema: GetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetSchemaEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet', 'schema', schema)
            const localVarPath = `/entities/api/v1/schemas/{schema}/json_schema`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{env}/{schema}
         * @summary List entities by schema (DEPRECATED)
         * @param {string} schema 
         * @param {ListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetEnvEnum} env 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet: async (schema: string, env: ListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetEnvEnum, limit?: number, pageToken?: string | null, filter?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet', 'schema', schema)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet', 'env', env)
            const localVarPath = `/entities/api/v1/entities/{env}/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{schema}
         * @summary List entities by schema (DEPRECATED)
         * @param {string} schema 
         * @param {number} [limit] 
         * @param {ListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetEnvEnum} [env] 
         * @param {string | null} [pageToken] 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet: async (schema: string, limit?: number, env?: ListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetEnvEnum, pageToken?: string | null, filter?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet', 'schema', schema)
            const localVarPath = `/entities/api/v1/entities/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Entities By Schema V2
         * @param {string} schema 
         * @param {ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetEnvEnum} env 
         * @param {number} [pageLimit] 
         * @param {string | null} [pageColumn] 
         * @param {string | null} [pageCursor] 
         * @param {ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetPageDirectionEnum} [pageDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet: async (schema: string, env: ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetEnvEnum, pageLimit?: number, pageColumn?: string | null, pageCursor?: string | null, pageDirection?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetPageDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet', 'schema', schema)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet', 'env', env)
            const localVarPath = `/entities/api/v2/entities/{env}/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page[limit]'] = pageLimit;
            }

            if (pageColumn !== undefined) {
                localVarQueryParameter['page[column]'] = pageColumn;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page[cursor]'] = pageCursor;
            }

            if (pageDirection !== undefined) {
                localVarQueryParameter['page[direction]'] = pageDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Entities By Schema V2
         * @param {string} schema 
         * @param {ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetEnvEnum} [env] 
         * @param {number} [pageLimit] 
         * @param {string | null} [pageColumn] 
         * @param {string | null} [pageCursor] 
         * @param {ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetPageDirectionEnum} [pageDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet: async (schema: string, env?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetEnvEnum, pageLimit?: number, pageColumn?: string | null, pageCursor?: string | null, pageDirection?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetPageDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet', 'schema', schema)
            const localVarPath = `/entities/api/v2/entities/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page[limit]'] = pageLimit;
            }

            if (pageColumn !== undefined) {
                localVarQueryParameter['page[column]'] = pageColumn;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page[cursor]'] = pageCursor;
            }

            if (pageDirection !== undefined) {
                localVarQueryParameter['page[direction]'] = pageDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Schemas
         * @param {ListSchemasEntitiesApiV1SchemasSchemaGetSchemaEnum} schema 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchemasEntitiesApiV1SchemasSchemaGet: async (schema: ListSchemasEntitiesApiV1SchemasSchemaGetSchemaEnum, limit?: number, pageToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('listSchemasEntitiesApiV1SchemasSchemaGet', 'schema', schema)
            const localVarPath = `/entities/api/v1/schemas/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Load multiple entities of a given type
         * @param {LoadEntitiesRequest} loadEntitiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost: async (loadEntitiesRequest: LoadEntitiesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loadEntitiesRequest' is not null or undefined
            assertParamExists('loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost', 'loadEntitiesRequest', loadEntitiesRequest)
            const localVarPath = `/entities/api/v1/operations/load-entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loadEntitiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {PutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutEnvEnum} env 
         * @param {EntityResource} entityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut: async (schema: string, entityId: string, env: PutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutEnvEnum, entityResource: EntityResource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut', 'entityId', entityId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut', 'env', env)
            // verify required parameter 'entityResource' is not null or undefined
            assertParamExists('putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut', 'entityResource', entityResource)
            const localVarPath = `/entities/api/v1/entity/{env}/{schema}/{entity_id}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {EntityResource} entityResource 
         * @param {PutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutEnvEnum} [env] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut: async (schema: string, entityId: string, entityResource: EntityResource, env?: PutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutEnvEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut', 'entityId', entityId)
            // verify required parameter 'entityResource' is not null or undefined
            assertParamExists('putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut', 'entityResource', entityResource)
            const localVarPath = `/entities/api/v1/entity/{schema}/{entity_id}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (env !== undefined) {
                localVarQueryParameter['env'] = env;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Entity Upload Job
         * @param {string} entityId 
         * @param {PutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutEnvEnum} env 
         * @param {EntityUploadDatasetJobRequestBody} entityUploadDatasetJobRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut: async (entityId: string, env: PutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutEnvEnum, entityUploadDatasetJobRequestBody: EntityUploadDatasetJobRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut', 'entityId', entityId)
            // verify required parameter 'env' is not null or undefined
            assertParamExists('putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut', 'env', env)
            // verify required parameter 'entityUploadDatasetJobRequestBody' is not null or undefined
            assertParamExists('putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut', 'entityUploadDatasetJobRequestBody', entityUploadDatasetJobRequestBody)
            const localVarPath = `/entities/api/v1/entity/{env}/Entity/{entity_id}/file_upload`
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"env"}}`, encodeURIComponent(String(env)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityUploadDatasetJobRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Schema
         * @param {PutSchemaEntitiesApiV1SchemaSchemaEntityIdPutSchemaEnum} schema 
         * @param {string} entityId 
         * @param {EntityResource} entityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSchemaEntitiesApiV1SchemaSchemaEntityIdPut: async (schema: PutSchemaEntitiesApiV1SchemaSchemaEntityIdPutSchemaEnum, entityId: string, entityResource: EntityResource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('putSchemaEntitiesApiV1SchemaSchemaEntityIdPut', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('putSchemaEntitiesApiV1SchemaSchemaEntityIdPut', 'entityId', entityId)
            // verify required parameter 'entityResource' is not null or undefined
            assertParamExists('putSchemaEntitiesApiV1SchemaSchemaEntityIdPut', 'entityResource', entityResource)
            const localVarPath = `/entities/api/v1/schema/{schema}/{entity_id}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put Schemas
         * @param {PutSchemasEntitiesApiV1SchemaSchemaPutSchemaEnum} schema 
         * @param {Array<EntityResource>} entityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSchemasEntitiesApiV1SchemaSchemaPut: async (schema: PutSchemasEntitiesApiV1SchemaSchemaPutSchemaEnum, entityResource: Array<EntityResource>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('putSchemasEntitiesApiV1SchemaSchemaPut', 'schema', schema)
            // verify required parameter 'entityResource' is not null or undefined
            assertParamExists('putSchemasEntitiesApiV1SchemaSchemaPut', 'entityResource', entityResource)
            const localVarPath = `/entities/api/v1/schema/{schema}`
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityResource, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reveal a sensitive field for an entity
         * @param {RevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetEnvEnum} env 
         * @param {string} schema 
         * @param {string} entityId 
         * @param {string} field 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet: async (env: RevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetEnvEnum, schema: string, entityId: string, field: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'env' is not null or undefined
            assertParamExists('revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet', 'env', env)
            // verify required parameter 'schema' is not null or undefined
            assertParamExists('revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet', 'schema', schema)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet', 'entityId', entityId)
            // verify required parameter 'field' is not null or undefined
            assertParamExists('revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet', 'field', field)
            const localVarPath = `/entities/api/v1/entity/{env}/{schema}/{entity_id}/reveal/{field}`
                .replace(`{${"env"}}`, encodeURIComponent(String(env)))
                .replace(`{${"schema"}}`, encodeURIComponent(String(schema)))
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {DeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteEnvEnum} env 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete(schema: string, entityId: string, env: DeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteEnvEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete(schema, entityId, env, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Enriched Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetEnvEnum} env 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet(schema: string, entityId: string, env: GetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetEnvEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet(schema, entityId, env, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Enriched Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetEnvEnum} [env] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet(schema: string, entityId: string, env?: GetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetEnvEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet(schema, entityId, env, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetEnvEnum} env 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet(schema: string, entityId: string, env: GetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetEnvEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet(schema, entityId, env, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetEnvEnum} [env] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet(schema: string, entityId: string, env?: GetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetEnvEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet(schema, entityId, env, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{env}/{schema}/{entity_id}/related_entities
         * @summary Get related entities (DEPRECATED)
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetEnvEnum} env 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet(schema: string, entityId: string, env: GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetEnvEnum, limit?: number, pageToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelatedListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet(schema, entityId, env, limit, pageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{schema}/{entity_id}/related_entities
         * @summary Get related entities (DEPRECATED)
         * @param {string} schema 
         * @param {string} entityId 
         * @param {GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetEnvEnum} [env] 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet(schema: string, entityId: string, env?: GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetEnvEnum, limit?: number, pageToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelatedListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet(schema, entityId, env, limit, pageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get related entities for a specific entity based on a relationship.  Two scenarios: 1. Outbound: entity_schema == from_schema - Get entities referenced by this entity 2. Inbound: entity_schema == target_schema - Get entities that reference this entity
         * @summary Get Related Entities V2
         * @param {string} entitySchema 
         * @param {string} entityId 
         * @param {string} fromSchema 
         * @param {string} propertyName 
         * @param {string} targetSchema 
         * @param {number} [pageLimit] 
         * @param {GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetEnvEnum} [env] 
         * @param {string | null} [pageCursor] 
         * @param {GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetPageDirectionEnum} [pageDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet(entitySchema: string, entityId: string, fromSchema: string, propertyName: string, targetSchema: string, pageLimit?: number, env?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetEnvEnum, pageCursor?: string | null, pageDirection?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetPageDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResourcePageRelatedV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet(entitySchema, entityId, fromSchema, propertyName, targetSchema, pageLimit, env, pageCursor, pageDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get related entities for a specific entity based on a relationship.  Two scenarios: 1. Outbound: entity_schema == from_schema - Get entities referenced by this entity 2. Inbound: entity_schema == target_schema - Get entities that reference this entity
         * @summary Get Related Entities V2
         * @param {string} entitySchema 
         * @param {string} entityId 
         * @param {GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetEnvEnum} env 
         * @param {string} fromSchema 
         * @param {string} propertyName 
         * @param {string} targetSchema 
         * @param {number} [pageLimit] 
         * @param {string | null} [pageCursor] 
         * @param {GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetPageDirectionEnum} [pageDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet(entitySchema: string, entityId: string, env: GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetEnvEnum, fromSchema: string, propertyName: string, targetSchema: string, pageLimit?: number, pageCursor?: string | null, pageDirection?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetPageDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResourcePageRelatedV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet(entitySchema, entityId, env, fromSchema, propertyName, targetSchema, pageLimit, pageCursor, pageDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Schema Json Schema
         * @param {GetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetSchemaEnum} schema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet(schema: GetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetSchemaEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet(schema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{env}/{schema}
         * @summary List entities by schema (DEPRECATED)
         * @param {string} schema 
         * @param {ListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetEnvEnum} env 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet(schema: string, env: ListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetEnvEnum, limit?: number, pageToken?: string | null, filter?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResourcePage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet(schema, env, limit, pageToken, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{schema}
         * @summary List entities by schema (DEPRECATED)
         * @param {string} schema 
         * @param {number} [limit] 
         * @param {ListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetEnvEnum} [env] 
         * @param {string | null} [pageToken] 
         * @param {Array<string>} [filter] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet(schema: string, limit?: number, env?: ListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetEnvEnum, pageToken?: string | null, filter?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResourcePage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet(schema, limit, env, pageToken, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Entities By Schema V2
         * @param {string} schema 
         * @param {ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetEnvEnum} env 
         * @param {number} [pageLimit] 
         * @param {string | null} [pageColumn] 
         * @param {string | null} [pageCursor] 
         * @param {ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetPageDirectionEnum} [pageDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet(schema: string, env: ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetEnvEnum, pageLimit?: number, pageColumn?: string | null, pageCursor?: string | null, pageDirection?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetPageDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResourcePageV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet(schema, env, pageLimit, pageColumn, pageCursor, pageDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Entities By Schema V2
         * @param {string} schema 
         * @param {ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetEnvEnum} [env] 
         * @param {number} [pageLimit] 
         * @param {string | null} [pageColumn] 
         * @param {string | null} [pageCursor] 
         * @param {ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetPageDirectionEnum} [pageDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet(schema: string, env?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetEnvEnum, pageLimit?: number, pageColumn?: string | null, pageCursor?: string | null, pageDirection?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetPageDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResourcePageV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet(schema, env, pageLimit, pageColumn, pageCursor, pageDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Schemas
         * @param {ListSchemasEntitiesApiV1SchemasSchemaGetSchemaEnum} schema 
         * @param {number} [limit] 
         * @param {string | null} [pageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSchemasEntitiesApiV1SchemasSchemaGet(schema: ListSchemasEntitiesApiV1SchemasSchemaGetSchemaEnum, limit?: number, pageToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResourcePage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSchemasEntitiesApiV1SchemasSchemaGet(schema, limit, pageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listSchemasEntitiesApiV1SchemasSchemaGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Load multiple entities of a given type
         * @param {LoadEntitiesRequest} loadEntitiesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost(loadEntitiesRequest: LoadEntitiesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadEntitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost(loadEntitiesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Put Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {PutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutEnvEnum} env 
         * @param {EntityResource} entityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut(schema: string, entityId: string, env: PutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutEnvEnum, entityResource: EntityResource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut(schema, entityId, env, entityResource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Put Entity By Schema
         * @param {string} schema 
         * @param {string} entityId 
         * @param {EntityResource} entityResource 
         * @param {PutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutEnvEnum} [env] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut(schema: string, entityId: string, entityResource: EntityResource, env?: PutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutEnvEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut(schema, entityId, entityResource, env, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Put Entity Upload Job
         * @param {string} entityId 
         * @param {PutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutEnvEnum} env 
         * @param {EntityUploadDatasetJobRequestBody} entityUploadDatasetJobRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut(entityId: string, env: PutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutEnvEnum, entityUploadDatasetJobRequestBody: EntityUploadDatasetJobRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityUploadDatasetJob>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut(entityId, env, entityUploadDatasetJobRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Put Schema
         * @param {PutSchemaEntitiesApiV1SchemaSchemaEntityIdPutSchemaEnum} schema 
         * @param {string} entityId 
         * @param {EntityResource} entityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSchemaEntitiesApiV1SchemaSchemaEntityIdPut(schema: PutSchemaEntitiesApiV1SchemaSchemaEntityIdPutSchemaEnum, entityId: string, entityResource: EntityResource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSchemaEntitiesApiV1SchemaSchemaEntityIdPut(schema, entityId, entityResource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putSchemaEntitiesApiV1SchemaSchemaEntityIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Put Schemas
         * @param {PutSchemasEntitiesApiV1SchemaSchemaPutSchemaEnum} schema 
         * @param {Array<EntityResource>} entityResource 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSchemasEntitiesApiV1SchemaSchemaPut(schema: PutSchemasEntitiesApiV1SchemaSchemaPutSchemaEnum, entityResource: Array<EntityResource>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSchemasEntitiesApiV1SchemaSchemaPut(schema, entityResource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putSchemasEntitiesApiV1SchemaSchemaPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reveal a sensitive field for an entity
         * @param {RevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetEnvEnum} env 
         * @param {string} schema 
         * @param {string} entityId 
         * @param {string} field 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet(env: RevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetEnvEnum, schema: string, entityId: string, field: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet(env, schema, entityId, field, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Entity By Schema
         * @param {DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete(requestParameters: DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Enriched Entity By Schema
         * @param {DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet(requestParameters: DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityMap> {
            return localVarFp.getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Enriched Entity By Schema
         * @param {DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet(requestParameters: DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityMap> {
            return localVarFp.getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Entity By Schema
         * @param {DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet(requestParameters: DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResource> {
            return localVarFp.getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Entity By Schema
         * @param {DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet(requestParameters: DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResource> {
            return localVarFp.getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{env}/{schema}/{entity_id}/related_entities
         * @summary Get related entities (DEPRECATED)
         * @param {DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet(requestParameters: DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RelatedListPage> {
            return localVarFp.getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{schema}/{entity_id}/related_entities
         * @summary Get related entities (DEPRECATED)
         * @param {DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet(requestParameters: DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<RelatedListPage> {
            return localVarFp.getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get related entities for a specific entity based on a relationship.  Two scenarios: 1. Outbound: entity_schema == from_schema - Get entities referenced by this entity 2. Inbound: entity_schema == target_schema - Get entities that reference this entity
         * @summary Get Related Entities V2
         * @param {DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet(requestParameters: DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResourcePageRelatedV2> {
            return localVarFp.getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet(requestParameters.entitySchema, requestParameters.entityId, requestParameters.fromSchema, requestParameters.propertyName, requestParameters.targetSchema, requestParameters.pageLimit, requestParameters.env, requestParameters.pageCursor, requestParameters.pageDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * Get related entities for a specific entity based on a relationship.  Two scenarios: 1. Outbound: entity_schema == from_schema - Get entities referenced by this entity 2. Inbound: entity_schema == target_schema - Get entities that reference this entity
         * @summary Get Related Entities V2
         * @param {DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet(requestParameters: DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResourcePageRelatedV2> {
            return localVarFp.getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet(requestParameters.entitySchema, requestParameters.entityId, requestParameters.env, requestParameters.fromSchema, requestParameters.propertyName, requestParameters.targetSchema, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.pageDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Schema Json Schema
         * @param {DefaultApiGetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet(requestParameters: DefaultApiGetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet(requestParameters.schema, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{env}/{schema}
         * @summary List entities by schema (DEPRECATED)
         * @param {DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet(requestParameters: DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResourcePage> {
            return localVarFp.listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet(requestParameters.schema, requestParameters.env, requestParameters.limit, requestParameters.pageToken, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is deprecated. Please use the v2 version: /v2/entities/{schema}
         * @summary List entities by schema (DEPRECATED)
         * @param {DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet(requestParameters: DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResourcePage> {
            return localVarFp.listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet(requestParameters.schema, requestParameters.limit, requestParameters.env, requestParameters.pageToken, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Entities By Schema V2
         * @param {DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet(requestParameters: DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResourcePageV2> {
            return localVarFp.listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet(requestParameters.schema, requestParameters.env, requestParameters.pageLimit, requestParameters.pageColumn, requestParameters.pageCursor, requestParameters.pageDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Entities By Schema V2
         * @param {DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet(requestParameters: DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResourcePageV2> {
            return localVarFp.listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet(requestParameters.schema, requestParameters.env, requestParameters.pageLimit, requestParameters.pageColumn, requestParameters.pageCursor, requestParameters.pageDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Schemas
         * @param {DefaultApiListSchemasEntitiesApiV1SchemasSchemaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchemasEntitiesApiV1SchemasSchemaGet(requestParameters: DefaultApiListSchemasEntitiesApiV1SchemasSchemaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResourcePage> {
            return localVarFp.listSchemasEntitiesApiV1SchemasSchemaGet(requestParameters.schema, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Load multiple entities of a given type
         * @param {DefaultApiLoadEntitiesEntitiesApiV1OperationsLoadEntitiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost(requestParameters: DefaultApiLoadEntitiesEntitiesApiV1OperationsLoadEntitiesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoadEntitiesResponse> {
            return localVarFp.loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost(requestParameters.loadEntitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Entity By Schema
         * @param {DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut(requestParameters: DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResource> {
            return localVarFp.putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut(requestParameters.schema, requestParameters.entityId, requestParameters.env, requestParameters.entityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Entity By Schema
         * @param {DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut(requestParameters: DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResource> {
            return localVarFp.putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut(requestParameters.schema, requestParameters.entityId, requestParameters.entityResource, requestParameters.env, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Entity Upload Job
         * @param {DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut(requestParameters: DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityUploadDatasetJob> {
            return localVarFp.putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut(requestParameters.entityId, requestParameters.env, requestParameters.entityUploadDatasetJobRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Schema
         * @param {DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSchemaEntitiesApiV1SchemaSchemaEntityIdPut(requestParameters: DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<EntityResource> {
            return localVarFp.putSchemaEntitiesApiV1SchemaSchemaEntityIdPut(requestParameters.schema, requestParameters.entityId, requestParameters.entityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put Schemas
         * @param {DefaultApiPutSchemasEntitiesApiV1SchemaSchemaPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSchemasEntitiesApiV1SchemaSchemaPut(requestParameters: DefaultApiPutSchemasEntitiesApiV1SchemaSchemaPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityResource>> {
            return localVarFp.putSchemasEntitiesApiV1SchemaSchemaPut(requestParameters.schema, requestParameters.entityResource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reveal a sensitive field for an entity
         * @param {DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet(requestParameters: DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet> {
            return localVarFp.revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet(requestParameters.env, requestParameters.schema, requestParameters.entityId, requestParameters.field, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete operation in DefaultApi.
 * @export
 * @interface DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteRequest
 */
export interface DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete
     */
    readonly env: DeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteEnvEnum
}

/**
 * Request parameters for getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetRequest
 */
export interface DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox' | 'schemas'}
     * @memberof DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet
     */
    readonly env: GetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetEnvEnum
}

/**
 * Request parameters for getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetRequest
 */
export interface DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox' | 'schemas'}
     * @memberof DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet
     */
    readonly env?: GetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetEnvEnum
}

/**
 * Request parameters for getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetRequest
 */
export interface DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet
     */
    readonly env: GetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetEnvEnum
}

/**
 * Request parameters for getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetRequest
 */
export interface DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet
     */
    readonly env?: GetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetEnvEnum
}

/**
 * Request parameters for getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetRequest
 */
export interface DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet
     */
    readonly env: GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetEnvEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet
     */
    readonly pageToken?: string | null
}

/**
 * Request parameters for getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetRequest
 */
export interface DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet
     */
    readonly env?: GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetEnvEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet
     */
    readonly pageToken?: string | null
}

/**
 * Request parameters for getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetRequest
 */
export interface DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly entitySchema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly entityId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly fromSchema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly propertyName: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly targetSchema: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly pageLimit?: number

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly env?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetEnvEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly pageCursor?: string | null

    /**
     * 
     * @type {'backward' | 'forward'}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet
     */
    readonly pageDirection?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetPageDirectionEnum
}

/**
 * Request parameters for getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetRequest
 */
export interface DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly entitySchema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly env: GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetEnvEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly fromSchema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly propertyName: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly targetSchema: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly pageLimit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly pageCursor?: string | null

    /**
     * 
     * @type {'backward' | 'forward'}
     * @memberof DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet
     */
    readonly pageDirection?: GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetPageDirectionEnum
}

/**
 * Request parameters for getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet operation in DefaultApi.
 * @export
 * @interface DefaultApiGetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetRequest
 */
export interface DefaultApiGetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetRequest {
    /**
     * 
     * @type {'Entity'}
     * @memberof DefaultApiGetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet
     */
    readonly schema: GetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetSchemaEnum
}

/**
 * Request parameters for listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet operation in DefaultApi.
 * @export
 * @interface DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetRequest
 */
export interface DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet
     */
    readonly schema: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet
     */
    readonly env: ListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetEnvEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet
     */
    readonly pageToken?: string | null

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet
     */
    readonly filter?: Array<string>
}

/**
 * Request parameters for listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet operation in DefaultApi.
 * @export
 * @interface DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetRequest
 */
export interface DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet
     */
    readonly schema: string

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet
     */
    readonly limit?: number

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet
     */
    readonly env?: ListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetEnvEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet
     */
    readonly pageToken?: string | null

    /**
     * 
     * @type {Array<string>}
     * @memberof DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet
     */
    readonly filter?: Array<string>
}

/**
 * Request parameters for listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet operation in DefaultApi.
 * @export
 * @interface DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetRequest
 */
export interface DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet
     */
    readonly schema: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet
     */
    readonly env: ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetEnvEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet
     */
    readonly pageLimit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet
     */
    readonly pageColumn?: string | null

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet
     */
    readonly pageCursor?: string | null

    /**
     * 
     * @type {'backward' | 'forward'}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet
     */
    readonly pageDirection?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetPageDirectionEnum
}

/**
 * Request parameters for listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet operation in DefaultApi.
 * @export
 * @interface DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetRequest
 */
export interface DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet
     */
    readonly schema: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet
     */
    readonly env?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetEnvEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet
     */
    readonly pageLimit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet
     */
    readonly pageColumn?: string | null

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet
     */
    readonly pageCursor?: string | null

    /**
     * 
     * @type {'backward' | 'forward'}
     * @memberof DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet
     */
    readonly pageDirection?: ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetPageDirectionEnum
}

/**
 * Request parameters for listSchemasEntitiesApiV1SchemasSchemaGet operation in DefaultApi.
 * @export
 * @interface DefaultApiListSchemasEntitiesApiV1SchemasSchemaGetRequest
 */
export interface DefaultApiListSchemasEntitiesApiV1SchemasSchemaGetRequest {
    /**
     * 
     * @type {'Entity'}
     * @memberof DefaultApiListSchemasEntitiesApiV1SchemasSchemaGet
     */
    readonly schema: ListSchemasEntitiesApiV1SchemasSchemaGetSchemaEnum

    /**
     * 
     * @type {number}
     * @memberof DefaultApiListSchemasEntitiesApiV1SchemasSchemaGet
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof DefaultApiListSchemasEntitiesApiV1SchemasSchemaGet
     */
    readonly pageToken?: string | null
}

/**
 * Request parameters for loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost operation in DefaultApi.
 * @export
 * @interface DefaultApiLoadEntitiesEntitiesApiV1OperationsLoadEntitiesPostRequest
 */
export interface DefaultApiLoadEntitiesEntitiesApiV1OperationsLoadEntitiesPostRequest {
    /**
     * 
     * @type {LoadEntitiesRequest}
     * @memberof DefaultApiLoadEntitiesEntitiesApiV1OperationsLoadEntitiesPost
     */
    readonly loadEntitiesRequest: LoadEntitiesRequest
}

/**
 * Request parameters for putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut operation in DefaultApi.
 * @export
 * @interface DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutRequest
 */
export interface DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut
     */
    readonly env: PutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutEnvEnum

    /**
     * 
     * @type {EntityResource}
     * @memberof DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut
     */
    readonly entityResource: EntityResource
}

/**
 * Request parameters for putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut operation in DefaultApi.
 * @export
 * @interface DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutRequest
 */
export interface DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut
     */
    readonly entityId: string

    /**
     * 
     * @type {EntityResource}
     * @memberof DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut
     */
    readonly entityResource: EntityResource

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut
     */
    readonly env?: PutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutEnvEnum
}

/**
 * Request parameters for putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut operation in DefaultApi.
 * @export
 * @interface DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutRequest
 */
export interface DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutRequest {
    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut
     */
    readonly entityId: string

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut
     */
    readonly env: PutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutEnvEnum

    /**
     * 
     * @type {EntityUploadDatasetJobRequestBody}
     * @memberof DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut
     */
    readonly entityUploadDatasetJobRequestBody: EntityUploadDatasetJobRequestBody
}

/**
 * Request parameters for putSchemaEntitiesApiV1SchemaSchemaEntityIdPut operation in DefaultApi.
 * @export
 * @interface DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPutRequest
 */
export interface DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPutRequest {
    /**
     * 
     * @type {'Entity'}
     * @memberof DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPut
     */
    readonly schema: PutSchemaEntitiesApiV1SchemaSchemaEntityIdPutSchemaEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPut
     */
    readonly entityId: string

    /**
     * 
     * @type {EntityResource}
     * @memberof DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPut
     */
    readonly entityResource: EntityResource
}

/**
 * Request parameters for putSchemasEntitiesApiV1SchemaSchemaPut operation in DefaultApi.
 * @export
 * @interface DefaultApiPutSchemasEntitiesApiV1SchemaSchemaPutRequest
 */
export interface DefaultApiPutSchemasEntitiesApiV1SchemaSchemaPutRequest {
    /**
     * 
     * @type {'Entity'}
     * @memberof DefaultApiPutSchemasEntitiesApiV1SchemaSchemaPut
     */
    readonly schema: PutSchemasEntitiesApiV1SchemaSchemaPutSchemaEnum

    /**
     * 
     * @type {Array<EntityResource>}
     * @memberof DefaultApiPutSchemasEntitiesApiV1SchemaSchemaPut
     */
    readonly entityResource: Array<EntityResource>
}

/**
 * Request parameters for revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet operation in DefaultApi.
 * @export
 * @interface DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetRequest
 */
export interface DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetRequest {
    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    readonly env: RevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetEnvEnum

    /**
     * 
     * @type {string}
     * @memberof DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    readonly schema: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    readonly entityId: string

    /**
     * 
     * @type {string}
     * @memberof DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet
     */
    readonly field: string
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Delete Entity By Schema
     * @param {DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete(requestParameters: DefaultApiDeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDelete(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Enriched Entity By Schema
     * @param {DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet(requestParameters: DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Enriched Entity By Schema
     * @param {DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet(requestParameters: DefaultApiGetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Entity By Schema
     * @param {DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet(requestParameters: DefaultApiGetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Entity By Schema
     * @param {DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet(requestParameters: DefaultApiGetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is deprecated. Please use the v2 version: /v2/entities/{env}/{schema}/{entity_id}/related_entities
     * @summary Get related entities (DEPRECATED)
     * @param {DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet(requestParameters: DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is deprecated. Please use the v2 version: /v2/entities/{schema}/{entity_id}/related_entities
     * @summary Get related entities (DEPRECATED)
     * @param {DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet(requestParameters: DefaultApiGetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGet(requestParameters.schema, requestParameters.entityId, requestParameters.env, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get related entities for a specific entity based on a relationship.  Two scenarios: 1. Outbound: entity_schema == from_schema - Get entities referenced by this entity 2. Inbound: entity_schema == target_schema - Get entities that reference this entity
     * @summary Get Related Entities V2
     * @param {DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet(requestParameters: DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGet(requestParameters.entitySchema, requestParameters.entityId, requestParameters.fromSchema, requestParameters.propertyName, requestParameters.targetSchema, requestParameters.pageLimit, requestParameters.env, requestParameters.pageCursor, requestParameters.pageDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get related entities for a specific entity based on a relationship.  Two scenarios: 1. Outbound: entity_schema == from_schema - Get entities referenced by this entity 2. Inbound: entity_schema == target_schema - Get entities that reference this entity
     * @summary Get Related Entities V2
     * @param {DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet(requestParameters: DefaultApiGetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGet(requestParameters.entitySchema, requestParameters.entityId, requestParameters.env, requestParameters.fromSchema, requestParameters.propertyName, requestParameters.targetSchema, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.pageDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Schema Json Schema
     * @param {DefaultApiGetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet(requestParameters: DefaultApiGetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGet(requestParameters.schema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is deprecated. Please use the v2 version: /v2/entities/{env}/{schema}
     * @summary List entities by schema (DEPRECATED)
     * @param {DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet(requestParameters: DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGet(requestParameters.schema, requestParameters.env, requestParameters.limit, requestParameters.pageToken, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is deprecated. Please use the v2 version: /v2/entities/{schema}
     * @summary List entities by schema (DEPRECATED)
     * @param {DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet(requestParameters: DefaultApiListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listEntitiesBySchemaEntitiesApiV1EntitiesSchemaGet(requestParameters.schema, requestParameters.limit, requestParameters.env, requestParameters.pageToken, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Entities By Schema V2
     * @param {DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet(requestParameters: DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGet(requestParameters.schema, requestParameters.env, requestParameters.pageLimit, requestParameters.pageColumn, requestParameters.pageCursor, requestParameters.pageDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Entities By Schema V2
     * @param {DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet(requestParameters: DefaultApiListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGet(requestParameters.schema, requestParameters.env, requestParameters.pageLimit, requestParameters.pageColumn, requestParameters.pageCursor, requestParameters.pageDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Schemas
     * @param {DefaultApiListSchemasEntitiesApiV1SchemasSchemaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listSchemasEntitiesApiV1SchemasSchemaGet(requestParameters: DefaultApiListSchemasEntitiesApiV1SchemasSchemaGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listSchemasEntitiesApiV1SchemasSchemaGet(requestParameters.schema, requestParameters.limit, requestParameters.pageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Load multiple entities of a given type
     * @param {DefaultApiLoadEntitiesEntitiesApiV1OperationsLoadEntitiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost(requestParameters: DefaultApiLoadEntitiesEntitiesApiV1OperationsLoadEntitiesPostRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loadEntitiesEntitiesApiV1OperationsLoadEntitiesPost(requestParameters.loadEntitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Entity By Schema
     * @param {DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut(requestParameters: DefaultApiPutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPut(requestParameters.schema, requestParameters.entityId, requestParameters.env, requestParameters.entityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Entity By Schema
     * @param {DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut(requestParameters: DefaultApiPutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPut(requestParameters.schema, requestParameters.entityId, requestParameters.entityResource, requestParameters.env, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Entity Upload Job
     * @param {DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut(requestParameters: DefaultApiPutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPut(requestParameters.entityId, requestParameters.env, requestParameters.entityUploadDatasetJobRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Schema
     * @param {DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putSchemaEntitiesApiV1SchemaSchemaEntityIdPut(requestParameters: DefaultApiPutSchemaEntitiesApiV1SchemaSchemaEntityIdPutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putSchemaEntitiesApiV1SchemaSchemaEntityIdPut(requestParameters.schema, requestParameters.entityId, requestParameters.entityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put Schemas
     * @param {DefaultApiPutSchemasEntitiesApiV1SchemaSchemaPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putSchemasEntitiesApiV1SchemaSchemaPut(requestParameters: DefaultApiPutSchemasEntitiesApiV1SchemaSchemaPutRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putSchemasEntitiesApiV1SchemaSchemaPut(requestParameters.schema, requestParameters.entityResource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reveal a sensitive field for an entity
     * @param {DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet(requestParameters: DefaultApiRevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).revealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGet(requestParameters.env, requestParameters.schema, requestParameters.entityId, requestParameters.field, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum DeleteEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdDeleteEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEnrichedEntityBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox',
    SCHEMAS = 'schemas'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEnrichedEntityBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox',
    SCHEMAS = 'schemas'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEntityBySchemaEntitiesApiV1EntitySchemaEntityIdGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaEntityIdRelatedEntitiesGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum GetRelatedEntitiesBySchemaEntitiesApiV1EntitiesSchemaEntityIdRelatedEntitiesGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum GetRelatedEntitiesV2EntitiesApiV2EntitiesEntitySchemaEntityIdRelatedGetPageDirectionEnum {
    BACKWARD = 'backward',
    FORWARD = 'forward'
}
/**
  * @export
  * @enum {string}
  */
export enum GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum GetRelatedEntitiesV2EntitiesApiV2EntitiesEnvEntitySchemaEntityIdRelatedGetPageDirectionEnum {
    BACKWARD = 'backward',
    FORWARD = 'forward'
}
/**
  * @export
  * @enum {string}
  */
export enum GetSchemaJsonSchemaEntitiesApiV1SchemasSchemaJsonSchemaGetSchemaEnum {
    ENTITY = 'Entity'
}
/**
  * @export
  * @enum {string}
  */
export enum ListEntitiesBySchemaEntitiesApiV1EntitiesEnvSchemaGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum ListEntitiesBySchemaEntitiesApiV1EntitiesSchemaGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum ListEntitiesBySchemaV2EntitiesApiV2EntitiesEnvSchemaGetPageDirectionEnum {
    BACKWARD = 'backward',
    FORWARD = 'forward'
}
/**
  * @export
  * @enum {string}
  */
export enum ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum ListEntitiesBySchemaV2EntitiesApiV2EntitiesSchemaGetPageDirectionEnum {
    BACKWARD = 'backward',
    FORWARD = 'forward'
}
/**
  * @export
  * @enum {string}
  */
export enum ListSchemasEntitiesApiV1SchemasSchemaGetSchemaEnum {
    ENTITY = 'Entity'
}
/**
  * @export
  * @enum {string}
  */
export enum PutEntityBySchemaEntitiesApiV1EntityEnvSchemaEntityIdPutEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum PutEntityBySchemaEntitiesApiV1EntitySchemaEntityIdPutEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum PutEntityUploadJobEntitiesApiV1EntityEnvEntityEntityIdFileUploadPutEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}
/**
  * @export
  * @enum {string}
  */
export enum PutSchemaEntitiesApiV1SchemaSchemaEntityIdPutSchemaEnum {
    ENTITY = 'Entity'
}
/**
  * @export
  * @enum {string}
  */
export enum PutSchemasEntitiesApiV1SchemaSchemaPutSchemaEnum {
    ENTITY = 'Entity'
}
/**
  * @export
  * @enum {string}
  */
export enum RevealEntityFieldEntitiesApiV1EntityEnvSchemaEntityIdRevealFieldGetEnvEnum {
    LIVE = 'live',
    SANDBOX = 'sandbox'
}


